module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    ref: "pageBox",
    staticClass: "cc-page"
  }, [_c('campaign-topbar', {
    on: {
      "new-chat": function($event) {
        _vm.showNewChatDialog = true
      },
      "export": _vm.exportChat
    }
  }), _vm._v(" "), _c('campaign-steps-bar', {
    attrs: {
      "current-step": _vm.currentStep,
      "steps": _vm.stepsLabels
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cc-body"
  }, [(_vm.showChat) ? _c('chat-panel', {
    key: _vm.chatInstanceKey,
    ref: "chatPanel",
    staticClass: "cc-chat",
    attrs: {
      "resume-chat-id": _vm.resumeChatId
    },
    on: {
      "summary-change": _vm.onSummaryChange
    }
  }) : _vm._e(), _vm._v(" "), _c('campaign-summary-sidebar', {
    staticClass: "cc-sidebar",
    attrs: {
      "current-step": _vm.currentStep,
      "summary": _vm.summary
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "cc-overlay-fade"
    }
  }, [(_vm.showNewChatDialog) ? _c('div', {
    staticClass: "cc-dialog-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showNewChatDialog = false
      }
    }
  }, [_c('div', {
    staticClass: "cc-dialog"
  }, [_c('h4', {
    staticClass: "cc-dialog-title"
  }, [_vm._v("Start a new chat?")]), _vm._v(" "), _c('p', {
    staticClass: "cc-dialog-body"
  }, [_vm._v("Your current campaign draft will be discarded and a fresh chat will begin.")]), _vm._v(" "), _c('div', {
    staticClass: "cc-dialog-actions"
  }, [_c('button', {
    staticClass: "cc-dialog-btn cc-dialog-btn-cancel",
    on: {
      "click": function($event) {
        _vm.showNewChatDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "cc-dialog-btn cc-dialog-btn-confirm",
    on: {
      "click": _vm.confirmNewChat
    }
  }, [_vm._v("Yes")])])])]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Nudge Console")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create Campaign")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9f573824","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/CreateCampaign.vue
// module id = jcvT
// module chunks = 1